<template>
  <modal
    :name="modalName"
    adaptive reset
    :scrollable="false"
    draggable=".window-header"
    @opened="opened"
    overlayTransition=""
    width="900"
    height="auto">

    <!-- height="470" -->
    <!-- https://github.com/euvl/vue-js-modal -->

    <h5 class="pop_tit window-header">
      오사용증표 입금 영수증
      <span class="right"> <span class="pop_close" @click="doClose"></span> </span>
    </h5>

    <s-report :src="report"/>

<!-- <pre>
영수증
회원명 : {{ sitem.membnm }} 귀하
변경 전 경유증표 : {{ sitem.caseclsfnm }}, {{ sitem.casetypenm }}, {{ sitem.org_viafee | comma }}원
변경 후 경유증표 : {{ sitem.to_caseclsfnm }}, {{ sitem.to_casetypenm }}, {{ sitem.to_viafee | comma }}원
차액금 : {{ sitem.diff_amt | comma }}원
발행일 : {{ sitem.payokdt }}
</pre>
 -->
  </modal>
</template>

<script>

let ui
const isDebug = false
export default {
  data () {
    return {
      report : '',
      sitem : { },
      loginInfo : {},
      modalName: "c오사용증표_차액입금_영수증_" + T.randomAZ(10),
      modal_title : '',
      viastatdt : '',
      viastatseq : '',
    }
  },
  created() {
    ui = this.$ui;
  },
  methods : {
    open(param) {
      this.viastatdt = param.viastatdt
      this.viastatseq = param.viastatseq

      this.sitem = _.cloneDeep(param)
      // 1. 상세 데이터 조회
      ui.httpGetDetail('/proc_iv/N_VIASTAT_SEL_DTL', {
          ..._.pick(param, ['viastatdt', 'viastatseq']),
        }, ret => {
          // let tmp = ret.data.rs1[0]
          this.sitem = ret.data.rs1[0]
          console.log("this.sitem : ", this.sitem)
        })

      this.modal_title = param.modal_title
      this.$modal.show(this.modalName);
    },
    opened() {
      this.doPrintReport()
    },
    doClose () {
      this.$modal.hide(this.modalName);
    },
    doPrintReport() {

      let url = "/ClipReport4/wrong_report.jsp"

      let params = {
        iv_viastatdt : this.viastatdt,
        iv_viastatseq : this.viastatseq,
        login_pers  :  this.$store.state.session.user.no
      }

      // params 객체를 urlQueryString 형식으로 변환
      let paramString = T.makeUrlQueryString(params)

      // report : url + 파라미터로 정의
      this.report = `${url}?${paramString}&r=` + Math.random()

    },
  }
}
</script>